module.exports = {"title":"JS - getting started","author":"jimmy yang","tags":["js"],"series":"101","date":"2017-01-01T00:00:00.000Z","lang":"en","body":"<p>Overview: choose the right tools.</p>\n<p>language: EC6, TypeScript, CoffeeScript</p>\n<p>ide: atom, vscode</p>\n<p>test tools: mocha</p>\n<p>package tools: npm , yarn</p>\n<p>multiple nodejs version: nvm</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./2016/101/js-getting-started.md
// module id = 717
// module chunks = 0